<template>
	<div>
		<el-dialog :title="$t('course_index.student_list')"  data-title="学生列表" width="1200px" :close-on-click-modal="false" :visible="isdialog" :before-close="guanbitanchu">
			<div class="filter-inline-panel cle">
				<el-form size="mini" :model="filters" class="filter-panel">
					<el-form-item :label="$t('course_index.theme')" prop="user_id">
						<el-input :value="
							(lang=='cn'?course_info.theme_cn:course_info.theme)+','+
							(lang=='cn'?course_info.teacher_name_cn:course_info.teacher_name)+','+
							getTime_week(course_info.have_date_time)+','+
							getTime_us(course_info.start_date,'mmddyyyy')+'~'+getTime_us(course_info.end_date,'mmddyyyy')+','+
							getTime_us(course_info.start_time,'hh:ii')+'~'+getTime_us(course_info.end_time,'hh:ii')
						" type="textarea" class="w100" :autosize="{ minRows: 1, maxRows: 1}"></el-input>
					</el-form-item>
				</el-form>
				<div class="list-opinion fr">
					<el-button type="primary" size="mini" @click="add()" data-name="添加学生">{{$t('index.add_student')}}</el-button>
					<el-button size="mini" type="primary" @click="ClassesExport()" data-name="学生名单导出">{{$t('course_index.list_export')}}</el-button>
					<el-button size="mini" type="primary" @click="class_notice('')" data-name="发送邮件">{{$t('index.class_notice')}}</el-button>
				</div>
			</div>
			<el-table :data="list" border size="mini" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="40"></el-table-column>
				<el-table-column prop="parent_name" align="center" :label="$t('student_list.parent_name')" data-name="家长姓名" width="100"></el-table-column>
				<!-- <el-table-column prop="email" align="center" :label="$t('student_list.email')" data-name="email" width="130"></el-table-column> -->
				<el-table-column prop="tel" align="center" :label="$t('student_list.tel')" data-name="电话" width="130"></el-table-column>
				<el-table-column prop="wechat_id" align="center" :label="$t('student_list.wechat')" data-name="微信ID"></el-table-column>
				<el-table-column prop="name" align="center" :label="$t('student_list.name')" data-name="学生名称" width="130">
					<template slot-scope="scope">
						<el-image v-if="scope.row.thumb" style="width: 50px; height: 50px" :src="scope.row.thumb" fit="contain"></el-image>
						<div>{{scope.row.name_cn}}</div>
						<div>{{scope.row.name}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="age" align="center" :label="$t('student_list.age')" data-name="年龄">
					<template slot-scope="scope"> {{scope.row.age>50?'成人':scope.row.age}} </template>
				</el-table-column>
				<el-table-column prop="remote_type" align="center" :label="$t('student_list.remote_type')" data-name="报名来源">
					<template slot-scope="scope"> {{scope.row.remote_type==1?$t('student_list.cn'):$t('student_list.en')}} </template>
				</el-table-column>
				<el-table-column prop="class_date_time" align="center" :label="$t('parent_index.trial_substitute')" data-name="试听" width="90">
					<template slot-scope="{row}">
						<p v-if="row.trip_course_type==1">{{$t('parent_index.trial_listening')}}</p>
						<p v-if="row.trip_course_type==2">{{$t('parent_index.substitute')}}</p>
						<p>{{getTime_us(row.class_date_time,'mmddyyyy')}} {{getTime_us(row.class_date_time,'hh:ii')}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="remarks" align="center" :label="$t('student_list.remarks')" data-name="备注" width="100"></el-table-column>
				<el-table-column prop="course_form" align="center" :label="$t('student_list.fields') " data-name="自定义字段"  width="100">
					<template slot-scope="{row}">
						<div class="tl" v-for="(item,index) in row.course_form">{{lang=='cn'?item.field_name_cn:item.field_name}}：<span style="cursor:pointer;" @click="field_click(item.value)">{{item.value}}</span></div>
					</template>
				</el-table-column>

				<el-table-column prop="user_remarks" align="center" :label="$t('student_list.parent_note')" data-name="家长备注" width="100"></el-table-column>
				<el-table-column prop="pay_price" align="center" :label="$t('student_list.pay_price')" data-name="实际支付金额" width="100"></el-table-column>
				<el-table-column prop="per_class_price" align="center" :label="$t('student_list.per_class_price')" data-name="每课金额" width="100"></el-table-column>
				<el-table-column prop="create_time" align="center" :label="$t('course_index.create_time')" data-name="报名时间">
					<template slot-scope="scope">{{getTime_us(scope.row.create_time,'mmddyyyy')}}</template>
				</el-table-column>
				<el-table-column :label="$t('index.operation')" align="center" width="300" fixed="right">
					<template slot-scope="scope">
						<!-- <div style="margin-bottom:10px;">
							<el-button size="mini" type="primary" @click="class_notice(scope.row)" data-name="发送邮件">{{$t('index.class_notice')}}</el-button>
							<el-button size="mini" type="primary" @click="remarks_edit(scope.row,1)" data-name="修改备注">{{$t('student_list.edit_remarks')}}</el-button>
						</div>
						<div style="margin-bottom:10px;">
							<el-button size="mini" type="primary" @click="remarks_edit(scope.row,2)" data-name="家长备注">{{$t('student_list.parent_note')}}</el-button>
							<el-button size="mini" type="primary" @click="custom_edit(scope.row)" data-name="自定义字段编辑">{{$t('student_list.custom_edit')}}</el-button>
							<el-button size="mini" type="primary" @click="seller_click(scope.row)" data-name="绑定销售">{{$t('index.seller')}}</el-button>
						</div> -->
						<!-- <el-button size="mini" type="danger" @click="del(scope.row)" data-name="停课">{{$t('order.suspend')}}</el-button> -->
						<el-button size="mini" type="danger" @click="del(scope.row)" data-name="删除">{{$t('index.del')}}</el-button>
						<el-button size="mini" type="primary" @click="custom_edit_price_form=scope.row,custom_edit_price=true" data-name="编辑金额">{{$t('student_list.custom_edit_price')}}</el-button>
						<el-dropdown @command="(e)=>{handleCommand(e,scope.row)}">
							<el-button size="mini">更多</el-button>
							<el-dropdown-menu slot="dropdown">
							    <el-dropdown-item command="a" data-name="发送邮件">{{$t('index.class_notice')}}</el-dropdown-item>
							    <el-dropdown-item command="b" data-name="修改备注">{{$t('student_list.edit_remarks')}}</el-dropdown-item>
							    <el-dropdown-item command="c" data-name="家长备注">{{$t('student_list.parent_note')}}</el-dropdown-item>
							    <el-dropdown-item command="d" data-name="自定义字段编辑">{{$t('student_list.custom_edit')}}</el-dropdown-item>
							    <el-dropdown-item command="e" data-name="删除">{{$t('index.del')}}</el-dropdown-item>
							    <el-dropdown-item command="suspend" data-name="停课">{{$t('order.suspend')}}</el-dropdown-item>
							    <el-dropdown-item command="f" data-name="绑定销售">{{$t('index.seller')}}</el-dropdown-item>
							    <el-dropdown-item command="j" data-name="编辑金额">{{$t('student_list.custom_edit_price')}}</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>
			</el-table>
			<div class="title">{{$t('journal.title')}}</div>
			<el-table :data="record_list" border size="mini">
				<el-table-column :prop="lang=='cn'?'course_name_cn':'course_name'" align="center" :label="$t('journal.name')"></el-table-column>
				<el-table-column prop="email" align="center" :label="$t('journal.admin_email')"></el-table-column>
				<el-table-column prop="child_name" align="center" :label="$t('journal.child_name')"></el-table-column>
				<el-table-column prop="user_name" align="center" :label="$t('journal.user_name')"></el-table-column>
				<el-table-column prop="create_time" align="center" :label="$t('journal.create_time')">
					<template slot-scope="scope">{{getTime_us(scope.row.create_time,'mmddyyyy')}}</template>
				</el-table-column>
				<el-table-column prop="action" align="center" :label="$t('index.operation')"></el-table-column>
				<el-table-column prop="remarks" align="center" :label="$t('student_list.remarks')"></el-table-column>
			</el-table>

			<el-dialog :title="$t('index.add_student')" data-title="添加学生" width="1000px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false" append-to-body>
				<el-row class="tree-content" :gutter="20">
					<el-form :model="editForm" size="mini" label-width="55px" label-position="top" :rules="editFormRules" ref="editForm">
						<el-col :span="12">
							<el-form-item :label="$t('student_list.parent_id')" prop="user_id">
								<el-input :value="editForm.user_id" placeholder="">
									<el-button slot="append" @click="userSearch">{{$t('index.select')}}</el-button>
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item :label="$t('student_list.student_id')" prop="child_id">
								<el-input :value="editForm.child_id" placeholder=""></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item :label="$t('student_list.parent_name')" prop="user_name">
								<div class="el-form-item__content">
									<div class="el-input el-input--mini">
										<div class="el-input__inner">{{editForm.user_name}}</div>
									</div>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item :label="$t('student_list.name')" prop="child_name">
								<div class="el-form-item__content">
									<div class="el-input el-input--mini">
										<div class="el-input__inner">{{editForm.child_name}}</div>
									</div>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item :label="$t('student_list.pay_price')" prop="pay_price" data-name="实际支付金额">
								<el-input :placeholder="$t('index.pleaseInput')" v-model="editForm.pay_price"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item :label="$t('student_list.per_class_price')" prop="per_class_price" data-name="每课金额">
								<el-input :placeholder="$t('index.pleaseInput')" v-model="editForm.per_class_price"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item :label="$t('student_list.old_course_id')" prop="old_course_id">
								<el-input :placeholder="$t('index.pleaseInput')" v-model="editForm.old_course_id"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item :label="$t('student_list.remarks')" prop="remarks">
								<el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" :placeholder="$t('index.pleaseInput')" v-model="editForm.remarks"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item :label="$t('parent_index.trial_substitute')" prop="trip_course_type">
								<el-radio-group v-model="editForm.trip_course_type">
									<el-radio :label="0">正式课</el-radio>
									<el-radio :label="1">{{$t('parent_index.trial_listening')}}</el-radio>
									<!-- <el-radio :label="2">{{$t('parent_index.substitute')}}</el-radio> -->
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-form>
				</el-row>
				<div slot="footer" class="dialog-footer">
					<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
					<el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
				</div>
				<el-dialog width="800px" :label="$t('student_list.parent_name')" :visible.sync="innerVisible" append-to-body @close="innerVisible = false" :close-on-click-modal="false">
					<el-form :inline="true" size="mini" :model="filters" class="filter-panel" ref="filters">
						<el-form-item :label="$t('student_list.tel')">
							<el-input v-model="filters.tel" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button size="mini" type="primary" @click="handleCurrentChange(1)">{{$t('index.search')}}</el-button>
						</el-form-item>
					</el-form>
					<el-table :data="userSearch_list" border size="mini">
						<el-table-column prop="id" align="center" :label="$t('student_list.parent_id')" data-name="家长ID"></el-table-column>
						<el-table-column prop="tel" align="center" :label="$t('student_list.tel')" data-name="tel"></el-table-column>
						<el-table-column prop="name" align="center" :label="$t('student_list.parent_name')" data-name="家长姓名"></el-table-column>
						<el-table-column prop="child_id" align="center" :label="$t('student_list.student_id')" data-name="学生ID"></el-table-column>
						<el-table-column prop="child_name" align="center" :label="$t('student_list.name')" data-name="学生"></el-table-column>
						<el-table-column :label="$t('index.operation')" align="center">
							<template slot-scope="scope">
								<el-button size="mini" type="primary" @click="determine(scope.row)">{{$t('index.determine')}}</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="page-pagination">
						<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
					</div>
				</el-dialog>
			</el-dialog>
			<el-dialog :title="$t('student_list.edit_remarks')" data-title="修改备注" width="500px" :close-on-click-modal="false" :visible="remarks_edit_is" @close="remarks_edit_is = false" append-to-body>
				<el-row class="tree-content" :gutter="20">
					<el-form :model="remarks" size="mini" label-width="55px" label-position="top" :rules="editFormRules" ref="remarks">
						<el-col :span="24">
							<el-form-item :label="$t('student_list.remarks')" prop="remarks">
								<el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" :placeholder="$t('index.pleaseInput')" v-model="remarks.remarks"></el-input>
							</el-form-item>
						</el-col>
					</el-form>
				</el-row>
				<div slot="footer" class="dialog-footer">
					<el-button size="mini" @click.native="remarks_edit_is = false">{{$t('index.cancel')}}</el-button>
					<el-button size="mini" type="primary" @click.native="editSubmit_remarks('')">{{$t('index.submit')}}</el-button>
				</div>
			</el-dialog>
			<el-dialog :title="$t('index.class_notice')" data-title="发送邮件" width="800px" :close-on-click-modal="false" :visible="class_notice_is" @close="class_notice_is = false" append-to-body>
				<el-row class="tree-content" :gutter="20">
					<el-form :model="class_notice_form" size="mini" label-width="55px" label-position="top" :rules="editFormRules" ref="class_notice_form">
						<el-col :span="24">
							<el-form-item :label="$t('student_list.title')" prop="title">
								<el-input :placeholder="$t('index.pleaseInput')" v-model="class_notice_form.title"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="24">
				            <editor-bar v-model="class_notice_form.content" :isClear="isClear"></editor-bar>
						</el-col>
					</el-form>
				</el-row>
				<div slot="footer" class="dialog-footer">
					<el-button size="mini" @click.native="class_notice_is = false">{{$t('index.cancel')}}</el-button>
					<el-button size="mini" type="primary" @click.native="openCourseByChild('')">{{$t('index.submit')}}</el-button>
				</div>
			</el-dialog>
			<el-dialog :title="$t('student_list.custom_edit')" data-title="自定义字段编辑" width="500px" :close-on-click-modal="false" :visible="custom_is" @close="custom_is = false" append-to-body>
				<el-form :model="custom_data" size="mini" label-width="55px" label-position="top" :rules="editFormRules" ref="custom_data">
					<template v-for="(item,index) in custom_data.course_form">
						<el-form-item
							:label="lang=='cn'?item.field_name_cn:item.field_name"
							:prop="'course_form.'+index+'.value'" 
							:rules="{required: item.is_must,message:($t('index.pleaseInput'))+(lang=='cn'?item.field_name_cn:item.field_name),trigger:'blur'}"
							:key="index">
							<el-input v-model="item.value" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</template>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="mini" @click.native="custom_is = false">{{$t('index.cancel')}}</el-button>
					<el-button size="mini" type="primary" @click.native="custom_fff('custom_data')">{{$t('index.submit')}}</el-button>
				</div>
			</el-dialog>
			<el-dialog :title="$t('index.seller')" data-title="绑定销售" width="500px" :close-on-click-modal="false" :visible="seller_is" @close="seller_is = false" append-to-body>
				<el-form :model="seller_form" size="mini" label-width="55px" label-position="top" :rules="editFormRules" ref="seller_form">
					<el-row :gutter="20">
						<el-col :span="24">
							<el-form-item :label="$t('index.seller')" prop="seller_id">
								<el-select v-model="seller_form.seller_id" clearable class="w100" :placeholder="$t('index.select')">
									<el-option v-for="(item,index) in sellerList" :key="index" :label="item.name" :value="item.id"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						
					</el-row>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="mini" @click.native="seller_is = false">{{$t('index.cancel')}}</el-button>
					<el-button size="mini" type="primary" @click.native="seller_fff('seller_form')">{{$t('index.submit')}}</el-button>
				</div>
			</el-dialog>
			<el-dialog :title="$t('student_list.custom_edit_price')" data-title="编辑金额" width="500px" :close-on-click-modal="false" :visible="custom_edit_price" @close="custom_edit_price = false" append-to-body>
				<el-form :model="custom_edit_price_form" size="mini" label-width="55px" label-position="top" :rules="editFormRules" ref="custom_edit_price_form">
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item :label="$t('student_list.pay_price')" prop="pay_price">
								<el-input-number v-model="custom_edit_price_form.pay_price" controls-position="right" :precision="2" class="w100" :min="0"></el-input-number>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item :label="$t('student_list.per_class_price')" prop="per_class_price">
								<el-input-number v-model="custom_edit_price_form.per_class_price" controls-position="right" :precision="2" class="w100" :min="0"></el-input-number>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="mini" @click.native="custom_edit_price = false">{{$t('index.cancel')}}</el-button>
					<el-button size="mini" type="primary" @click.native="custom_edit_price_submit('custom_edit_price_form')">{{$t('index.submit')}}</el-button>
				</div>

			</el-dialog>
		</el-dialog>
	</div>
</template>
<script>
// import EditorBar from '@/components/wangEnduit.vue'
export default {
	computed: {
		editFormRules() {
			return {
				country: [{
					required: true,
					message: this.$t('index.select') + this.$t('course_index.country'),
					trigger: 'change'
				}],
				email: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('student_list.email'),
					trigger: 'blur'
				}],
				email: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('student_list.email'),
					trigger: 'blur'
				}],
				pay_price: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('student_list.pay_price'),
					trigger: 'blur'
				}],
				per_class_price: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('student_list.per_class_price'),
					trigger: 'blur'
				}],
				user_id: [{
					required: true,
					message: this.$t('index.select') + this.$t('student_list.parent_id'),
					trigger: 'blur'
				}],
				child_id: [{
					required: true,
					message: this.$t('index.select') + this.$t('student_list.student_id'),
					trigger: 'blur'
				}],
			}
		},
	},
	components: {
		// EditorBar
	},

	props: {
		isdialog: {
			type: Boolean,
			default: false
		},
		id: {
			type: Number,
			default: 0
		},
	},
	data() {
		return {
			list: [],
			course_info: {},
			editFormVisible: false,
			innerVisible: false,
			remarks_edit_is: false,
			remarks_edit_is_new:0,
			isClear: false,
			editForm: {},
			filters: {
				tel: '',
			},
			userSearch_list: [],
			API_URL: process.env.API_URL,
			pages: {
				page: 1,
				count: 100,
				perpage: 10,
			},
			remarks: {
				remarks: '',
			},
			class_notice_is:false,
			class_notice_form:{

			},
			data_data:[],

			record_list:[],
			editForm1:{},
			custom_data:{},
			custom_is:false,
			sellerList:[],
			seller_is:false,
			seller_form:{},
			custom_edit_price:false,
			custom_edit_price_form:{
				id:'',
				pay_price:'',
				per_class_price:'',
			}
		}
	},
	watch: {
		isdialog(v){
			if (v) {
				this.init();
			}
		},
	},
	// 初始事件
	mounted: function () {
	},
	// 事件
	methods: {
		// 初始化
		init() {
			var this_ = this;
			var url = "courseClasses";
			var datas = {
				course_id: this_.id,
			};
			this_.$post(url, datas).then((res) => {
				var student = res.student;
				for (var i = 0; i < student.length; i++) {
					student[i]['remote_type'] = 1
				}
				var remote_student = res.remote_student;
				for (var i = 0; i < remote_student.length; i++) {
					remote_student[i]['remote_type'] = 2
				}
				this_.list = [...student,...remote_student];
				this_.course_info = res.course_info;
			})
			var url = "adminStudentRecord";
			var datas = {
				course_id: this_.id,
				type:'course',
				page:1,
				num:10000,
			};
			this_.$post(url, datas).then((res) => {
				this_.record_list = res.list;
			})
		},
		handleCommand(e,data){
			switch(e){
				case 'a':
					this.class_notice(data);
				break
				case 'b':
					this.remarks_edit(data,1);
				break
				case 'c':
					this.remarks_edit(data,2);
				break
				case 'd':
					this.custom_edit(data);
				break
				case 'e':
					this.del(data);
				break
				case 'f':
					this.seller_click(data);
				break
				case 'j':
					this.custom_edit_price_form=data;
					this.custom_edit_price=true
				break
				case 'suspend':
					this.classes_delete_flag(data);
				break
			}
		},
		add(data) {
			if (data) {
				var data_data = JSON.parse(JSON.stringify(data));
				this.editForm = data_data;
			} else {
				this.editForm = {
					user_id: '',
					child_id: '',
					pay_price: '',
					per_class_price: '',
					remarks: '',
					type: 'course',
					course_id: this.id,
					old_course_id:'',
					trip_course_type:0,
				}
			}
			if (this.$refs.editForm) {
				this.$refs.editForm.resetFields();
			}
			this.editFormVisible = true;
		},

		// 保存
		editSubmit(editForm) {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var datas = {
						user_id: this_.editForm.user_id,
						child_id: this_.editForm.child_id,
						pay_price: this_.editForm.pay_price,
						per_class_price: this_.editForm.per_class_price,
						remarks: this_.editForm.remarks,
						type: this_.editForm.type,
						course_id: this_.editForm.course_id,
						old_course_id: this_.editForm.old_course_id,
						trip_course_type: this_.editForm.trip_course_type,
					}
					var url = "addStudent";
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.operation_success'));
						this_.editFormVisible = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		// 查找学生
		userSearch() {
			var this_ = this;
			var url = "userSearch";
			var datas = {
				tel: this_.filters.tel,
				page: this_.pages.page,
				num: this_.pages.perpage,
			};
			this_.$post(url, datas).then((res) => {
				this_.userSearch_list = res.list;
				this_.pages.count = res.sum;
				this_.innerVisible = true;
			})
		},
		determine(data) {
			var this_ = this;
			this_.editForm['user_id'] = data.id;
			this_.editForm['user_name'] = data.name;
			this_.editForm['child_id'] = data.child_id;
			this_.editForm['child_name'] = data.child_name;
			this_.innerVisible = false;
		},

		remarks_edit(data,s) {
			this.remarks_edit_is_new=s;
			this.remarks = {
				id:s==1?data.id:data.user_id,
				remarks:s==1?data.remarks:data.user_remarks,
			}
			this.remarks_edit_is = true;
		},
		editSubmit_remarks() {
			var this_ = this;
			this_.$refs.remarks.validate((valid) => {
				if (valid) {
					if(this_.remarks_edit_is_new==1){
						var datas = {
							remarks: this_.remarks.remarks,
							id: this_.remarks.id,
						}
						var url = "addStudent";
						this_.$post(url, datas).then((res) => {
							this_.$message.success(this_.$t('index.operation_success'));
							this_.remarks_edit_is = false;
							this_.init();
						});
					}else{
						var datas = {
							table: 'user',
							field: 'remarks',
							value: this_.remarks.remarks,
							pk_id: this_.remarks.id,
						}
						var url = "changeField";
						this_.$post(url, datas).then((res) => {
							this_.$message.success(this_.$t('index.add_success'));
							this_.remarks_edit_is = false;
							this_.init();
						});
					}
				} else {
					return false;
				}
			})
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.userSearch();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.userSearch();
		},

		class_notice(data) {
			var this_ = this;
			this.class_notice_form={
				course_id:this.id,
				content:'',
				title:'',
			}
			if (data) {
				this.class_notice_form['child_ids']=data.child_id;
				this.class_notice_is=true;
			}else{
				if (this.data_data.length>0) {
					var child_ids=this.data_data.join(',');
					console.log(child_ids)
					this.class_notice_form['child_ids']=child_ids;
					this.class_notice_is=true;
				}else{
					this.$message.error(this_.$t('index.please_check'));
				}
			}
		},
		openCourseByChild(){
			var this_ = this;
			this_.$refs.class_notice_form.validate((valid) => {
				if (valid) {
					var datas = {
						title: this_.class_notice_form.title,
						content: this_.class_notice_form.content,
						course_id: this_.class_notice_form.course_id,
						child_ids: this_.class_notice_form.child_ids,
						type:'course',
					}
					var url = "openCourseByChild";
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.operation_success'));
						this_.class_notice_is = false;
					});
				} else {
					return false;
				}
			})

		},

		// 删除
		del(data) {
			var this_ = this;
			var url = "deleteStudent";
			var datas = {
				id: data.id,
			};
			this_.$confirm('确认删除吗?', '提示').then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success('删除成功');
					this_.init();
				})
			});
		},
		// 停课
		classes_delete_flag(data){
			var url = "deleteStudent";
			var datas = {
				id: data.id,
				classes_delete_flag:2
			};
			this.$post(url, datas).then((res) => {
				this.$message.success('停课成功');
				this.init();
			})
		},
		ClassesExport() {
			var course_id = this.id;
			var TokenId = sessionStorage.getItem('TokenId');
			var lang = localStorage.getItem('lang') != 'cn' ? 'us' : 'cn';
			var url = process.env.API_ROOT + 'ClassesExport?TokenId=' + TokenId + '&language=' + lang + '&course_id=' + course_id;
			window.open(url);
		},

		guanbitanchu(){
			this.list=[];
			this.$emit("guanbitanchu");
		},
		handleSelectionChange(data){
			var data_data=[];
			data.forEach(function(e,i) {
				data_data[i]=e.child_id;
			});
			console.log(data_data)
			this.data_data=data_data;
		},
		custom_edit(data){
			this.custom_data=data;
			this.custom_is=true;
		},
		custom_fff(editForm){
			var this_ = this;
			this_.$refs[editForm].validate((valid) => {
				if (valid) {
					var datas = {
						course_field:JSON.stringify(this_[editForm].course_form),
						course_id: this_.id,
						course_type:'course',
						child_id: this_[editForm].child_id,
					}
					var url = "editCourseForm";
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.operation_success'));
						this_.custom_is = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		field_click(value){
			if(value.indexOf('http')!=-1){
				var url=value.slice(value.indexOf('http'));
				window.open(url);
			}
		},
		seller_click(data){
			var this_ = this;
			var url = "sellerListNoPage";
			this_.$post(url, {seller_type:'seller'}).then((res) => {
				this_.sellerList = res;
				this_.seller_form={
					id:data.id,
					user_id:data.user_id,
					seller_id:data.seller_id||'',
				}
				this_.seller_is=true;
			})
		},
		seller_fff(editForm){
			this.$refs[editForm].validate((valid) => {
				if (valid) {
					var datas = {
						...this.seller_form
					}
					var url = "ClassesEditSeller";
					this.$post(url, datas).then((res) => {
						this.$message.success(this.$t('index.operation_success'));
						this.seller_is = false;
						this.init();
					});
				} else {
					return false;
				}
			})
		},
		// 编辑金额
		custom_edit_price_submit(){
			var datas = {
				id:this.custom_edit_price_form.id,
				pay_price:this.custom_edit_price_form.pay_price,
				per_class_price:this.custom_edit_price_form.per_class_price,
			}
			var url = "changeClassesPayprice";
			this.$post(url, datas).then((res) => {
				this.$message.success(this.$t('index.operation_success'));
				this.custom_edit_price = false;
				this.init();
			});
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.clo3 {
	color: #ff0000;
}
.filter-panel{
	width: calc( 100% - 400px );
	float: left;
}
.title{
	text-align: center;
	font-size: 20px;
	margin-top: 10px;
	line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/teacher_student_list.vue